/*eslint-disable*/
import React, { useEffect, useMemo, useState } from "react";
import {
    Card,
    CardContent,
    Typography,
    MenuItem,
    Select,
    FormControl,
    Grid,
    Box,
    Skeleton,
    CircularProgress,
} from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart"; // Import BarChart
import { SelectChangeEvent } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import FastAPIClient from "../../client";
import config from "../../config";
import CustomHorizontalBarChart from "./CustomHorizontalBarChart";
import ChartWithTable from "./ChartWithTable";
import StatCard from "../LayoutComponents/StatCard";

import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

const client = new FastAPIClient(config);

const formatNumber = (num: number | null): string => {
    console.log(num);
    if (num == null) return ""; // Handles null case
    if (Math.abs(num) >= 1_000_000) return (num / 1_000_000).toFixed(1) + "M";
    if (Math.abs(num) < 1_000_000 && Math.abs(num) >= 100_000)
        return (num / 1_000).toFixed(0) + "k";
    if (Math.abs(num) < 100_000) return (num / 1_000).toFixed(1) + "k";
    return num.toString();
};

type MonthlyStat = {
    user_id: string;
    first_name: string;
    last_name: string;
    warehouse_name: string;
    year: number;
    month: number;
    monthly_revenue: number;
    monthly_volume: number;
    monthly_margin: number;
    distinct_clients: number;
    team_name: string;
    product_level_1?: string; // 👈 Add this
    client_level_1?: string; // 👈 Add this
};

interface UserMeetingProps {
    unit: string;
    selectedUser: string;
    // selectedTeam: string;
    selectedWarehouse: string;
    // timePeriod: string;
    metricKey: "monthly_revenue" | "monthly_volume" | "monthly_margin";
    title: string;
    data: MonthlyStat[];
}

const MetricStats: React.FC<UserMeetingProps> = ({
    unit,
    selectedUser,
    // selectedTeam,
    selectedWarehouse,
    // timePeriod,
    metricKey,
    title,
    data,
}) => {
    // const [data, setData] = useState<MonthlyStat[] | null>(null);
    // const [selectedUser, setSelectedUser] = useState<string>("all");
    const [dateRange, setDateRange] = useState<[Dayjs | null, Dayjs | null]>([
        dayjs().startOf("week"),
        dayjs().endOf("week"),
    ]);
    // const [timePeriod, setTimePeriod] = useState<string>("last30Days");
    // const [selectedTeam, setSelectedTeam] = useState<string>("all");
    // const [selectedWarehouse, setSelectedWarehouse] = useState<string>("all");

    // const uniqueTeams = useMemo(() => {
    //     if (!data) return [];
    //     const teams = new Set(data.map((d) => d.team_name).filter(Boolean));
    //     return Array.from(teams);
    // }, [data]);

    // const uniqueWarehouses = useMemo(() => {
    //     if (!data) return [];
    //     const warehouses = new Set(
    //         data.map((d) => d.warehouse_name).filter(Boolean)
    //     );
    //     return Array.from(warehouses);
    // }, [data]);

    // useEffect(() => {
    //     switch (timePeriod) {
    //         case "last7Days":
    //             setDateRange([
    //                 dayjs().subtract(6, "day").startOf("day"),
    //                 dayjs().endOf("day"),
    //             ]);
    //             break;
    //         case "last30Days":
    //             setDateRange([
    //                 dayjs().subtract(29, "day").startOf("day"),
    //                 dayjs().endOf("day"),
    //             ]);
    //             break;
    //         case "lastMonth":
    //             setDateRange([
    //                 dayjs().subtract(1, "month").startOf("month"),
    //                 dayjs().subtract(1, "month").endOf("month"),
    //             ]);
    //             break;
    //         default:
    //             setDateRange([dayjs().startOf("week"), dayjs().endOf("week")]);
    //             break;
    //     }
    // }, [timePeriod]);

    // const handleTimePeriodChange = (event: SelectChangeEvent<string>) => {
    //     setTimePeriod(event.target.value);
    // };

    // const handleDateRangeChange = (newValue: [Dayjs | null, Dayjs | null]) => {
    //     setDateRange(newValue);
    // };

    // const uniqueUsers = useMemo(() => {
    //     if (!data) return [];
    //     const userMap = new Map<string, MonthlyStat>();

    //     data.forEach((user) => {
    //         const fullName = `${user.first_name} ${user.last_name}`;
    //         if (!userMap.has(fullName)) {
    //             userMap.set(fullName, user);
    //         }
    //     });

    //     return Array.from(userMap.values());
    // }, [data]);

    const filteredData = useMemo(() => {
        if (!data || !dateRange[0] || !dateRange[1]) return [];

        // const [start, end] = dateRange;
        let filtered = data;

        // const withDate = data.map((d) => ({
        //     ...d,
        //     date: dayjs(`${d.year}-${String(d.month).padStart(2, "0")}-01`),
        // }));

        // let filtered = withDate.filter((d) =>
        //     d.date.isBetween(start, end, null, "[]")
        // );

        // if (selectedTeam !== "all") {
        //     filtered = filtered.filter((d) => d.team_name === selectedTeam);
        // }

        if (selectedWarehouse !== "all") {
            filtered = filtered.filter(
                (d) => d.warehouse_name === selectedWarehouse
            );
        }

        if (selectedUser !== "all") {
            filtered = filtered.filter(
                (d) => `${d.first_name} ${d.last_name}` === selectedUser
            );
        }

        return filtered;
    }, [data, selectedUser, selectedWarehouse, dateRange]);

    const computeGroupDiff = (
        data: MonthlyStat[],
        groupKey: keyof MonthlyStat,
        metricKey: keyof MonthlyStat
    ): { label: string; value: number; change: number | null }[] => {
        const groupedByYear: Record<string, { [year: number]: number }> = {};

        data.forEach((entry) => {
            const key = entry[groupKey];
            if (!key) return;

            const group = groupedByYear[key] || {};
            group[entry.year] =
                (group[entry.year] || 0) + (entry[metricKey] as number);
            groupedByYear[key] = group;
        });

        return Object.entries(groupedByYear).map(([label, yearMap]) => ({
            label,
            value: yearMap[2025] || 0,
            change:
                yearMap[2025] != null && yearMap[2024] != null
                    ? yearMap[2025] - yearMap[2024]
                    : null,
        }));
    };

    const chartData = useMemo(() => {
        if (!filteredData) return { months: [], series: [] };

        const monthNames = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ];
        const yearMap: { [year: number]: number[] } = {};

        filteredData.forEach((entry) => {
            const { year, month } = entry;
            const value = entry[metricKey] as number;
            if (!yearMap[year]) yearMap[year] = new Array(12).fill(0);
            yearMap[year][month - 1] += value;
        });

        const series = Object.entries(yearMap).map(([year, values], index) => ({
            label: year,
            data: values,
            color: index === 0 ? "#dedede" : "#d3d3d3",
        }));

        console.log(series);
        console.log(series);

        return {
            months: monthNames,
            series,
        };
    }, [filteredData, metricKey]);

    const calculatedMaxY = Math.ceil(
        Math.max(...chartData.series.flatMap((s) => s.data))
    );

    const metricByWarehouse = useMemo(() => {
        return computeGroupDiff(filteredData, "warehouse_name", metricKey);
    }, [filteredData, metricKey]);

    const metricByProductLevel = useMemo(() => {
        return computeGroupDiff(filteredData, "product_level_1", metricKey);
    }, [filteredData, metricKey]);

    const metricByClientLevel = useMemo(() => {
        return computeGroupDiff(filteredData, "client_level_1", metricKey);
    }, [filteredData, metricKey]);

    const userNameMap = useMemo(() => {
        const map: { [key: string]: string } = {};
        data.forEach((d) => {
            map[d.user_id] = `${d.first_name} ${d.last_name}`;
        });
        return map;
    }, [data]);

    const metricByUser = useMemo(() => {
        const raw = computeGroupDiff(filteredData, "user_id", metricKey);
        return raw.map((item) => ({
            ...item,
            label: userNameMap[item.label] || item.label,
        }));
    }, [filteredData, metricKey, userNameMap]);

    const currentYear = dayjs().year();
    const previousYear = currentYear - 1;

    const totalMetricCurrentYear = useMemo(() => {
        return filteredData
            .filter((d) => d.year === currentYear)
            .reduce((sum, d) => sum + (d[metricKey] || 0), 0);
    }, [filteredData, metricKey]);

    const totalMetricPreviousYear = useMemo(() => {
        return filteredData
            .filter((d) => d.year === previousYear)
            .reduce((sum, d) => sum + (d[metricKey] || 0), 0);
    }, [filteredData, metricKey]);

    return (
        <StatCard
            title={title}
            value={`${formatNumber(totalMetricCurrentYear)} ${unit}`}
            currentYearValue={totalMetricCurrentYear}
            previousYearValue={totalMetricPreviousYear}
            loading={!data}
        >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box>
                    {selectedUser !== "all" || selectedWarehouse !== "all" ? (
                        <ChartWithTable
                            title="Par utilisateur"
                            data={metricByUser}
                            unit={unit}
                        />
                    ) : (
                        <ChartWithTable
                            title="Par dépôt"
                            data={metricByWarehouse}
                            unit={unit}
                        />
                    )}
                </Box>

                <Box>
                    <ChartWithTable
                        title="Par famille produits"
                        data={metricByProductLevel}
                        unit={unit}
                    />
                </Box>

                <Box>
                    <ChartWithTable
                        title="Par groupe clients"
                        data={metricByClientLevel}
                        defaultExpanded={false}
                        unit={unit}
                    />
                </Box>
                <Typography
                    variant="subtitle2"
                    gutterBottom
                    align="left"
                    fontSize="0.875rem"
                    sx={{ fontWeight: "bold" }} // This will make the font bold
                >
                    Comparaison mensuelle
                </Typography>
                {chartData.series.length === 0 ||
                chartData.series.every((s) => s.data.every((v) => v === 0)) ? (
                    <Grid
                        container
                        spacing={1}
                        alignItems="flex-end"
                        sx={{ height: 150, mt: 1 }}
                    >
                        {Array.from({ length: 12 }).map((_, idx) => (
                            <Grid size={1}>
                                <Skeleton
                                    variant="rectangular"
                                    width="100%"
                                    height={Math.floor(Math.random() * 80 + 40)} // variable height to mimic chart
                                    sx={{
                                        borderRadius: 1,
                                        backgroundColor: "#e0e0e0",
                                    }}
                                />
                            </Grid>
                        ))}
                    </Grid>
                ) : (
                    <BarChart
                        xAxis={[
                            {
                                data: chartData.months,
                                scaleType: "band",
                            },
                        ]}
                        yAxis={[
                            {
                                max: calculatedMaxY,
                                valueFormatter: formatNumber, // Add your formatter function here
                            },
                        ]}
                        hideLegend={true}
                        series={chartData.series}
                        borderRadius={10}
                        height={150}
                        margin={{
                            top: 20,
                            right: 0,
                            bottom: 0,
                            left: 0,
                        }}
                        grid={{ vertical: false, horizontal: true }}
                        sx={{
                            // backgroundColor: "black",
                            "& .MuiChartsAxis-left .MuiChartsAxis-line": {
                                display: "none",
                            },
                            "& .MuiChartsAxis-tickLabel span:first-of-type": {
                                fontWeight: "bold",
                            },
                            "& .MuiChartsAxis-bottom .MuiChartsAxis-line": {
                                display: "none",
                            },
                            "& .MuiChartsGrid-horizontalLine": {
                                stroke: "white",
                                strokeDasharray: "1 4",
                            },
                            "& .MuiChartsAxis-left .MuiChartsAxis-tickLabel": {
                                fill: "#000000",
                                fontSize: 12,
                                fontFamily: "Roboto",
                            },
                            "& .MuiChartsAxis-bottom .MuiChartsAxis-tick": {
                                display: "none",
                            },
                            "& .MuiChartsAxis-left .MuiChartsAxis-tick": {
                                display: "none",
                            },
                            "& .MuiChartsLegend-series text": {
                                fontSize: "0.7em !important",
                            },
                        }}
                    />
                )}
            </LocalizationProvider>
        </StatCard>
    );
};

export default MetricStats;
